// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"261": "4752969116ed","3616": "2bd20f1d2224","6729": "cbce1e671af9",}[chunkId] + ".css"
}